import React from 'react'
import { useMediaSize, Space, TextBody } from '@ally/metronome-ui'
import {
  getFirstName,
  getGreetingName,
} from '@ally/data-selectors-afg-customer'
import { Private } from '@ally/private'
import { useHostServices } from '../HostServices'
import { formatAsServerDate, capitalizeFirstLetter } from '../utils'

export const Greeting: React.FC = () => {
  const { hostData, session, featureFlags } = useHostServices()
  const isPreferredNameEnabled = featureFlags.variation(
    'FF_preferred-name-pronoun',
    false,
  )
  // if FF is turned off, show first name instead of preferred name
  const greetingName = isPreferredNameEnabled
    ? getGreetingName(hostData)
    : getFirstName(hostData)
  const isSmDown = useMediaSize('SmDown')
  const lastLoginTimeStamp = session.data?.lastLoginTime

  return (
    <>
      {greetingName ? (
        <Space mt="xs" mb="sm">
          <Private>
            <TextBody tag="p" size="md">
              Hello {capitalizeFirstLetter(greetingName)}
              {lastLoginTimeStamp && !isSmDown && (
                <>
                  {' '}
                  &bull; Last Login{' '}
                  {formatAsServerDate(lastLoginTimeStamp, 'MMM DD, YYYY')}
                  &bull; {formatAsServerDate(lastLoginTimeStamp, 'h:mm A')} ET
                </>
              )}
            </TextBody>
          </Private>
        </Space>
      ) : null}
    </>
  )
}
